export const invoice = {
	companyName: "Fastest Solution s.r.o.",
	street: "Benešovská 1973/20",
	city: "101 00 Praha 10",
	ic: "28591232",
	dic: "CZ28591232",
	email: "ucetni@fastest.cz",
	bankAccount: "230298084/0300",
	databox: "2jg5w8i",
};

export const office = {
	street: "Pobialova 819/14",
	desc: "3. a 4. patro",
	city: "702 00 Ostrava",
	email: "info@fastest.cz",
	phoneCEO: "+420 773 050 550",
	phoneSupport: "+420 773 108 020",
};

export const socialLinks = {
	facebook: "https://www.facebook.com/fastest.solution",
	instagram: "https://www.instagram.com/fastestsolutioncz/",
	linkedin: "https://www.linkedin.com/company/fastestsolution/",
};
